import {Radio, Stack, Typography, styled} from '@mui/material';

export const ProtocolItemHeaderContainer = styled(Stack)`
	width: 100%;
	flex-direction: row;
	align-items: flex-start;
	gap: 4px;
`;

export const StyledRadio = styled(Radio)`
	padding: 9px;
`;

export const TitleTypography = styled(Typography)`
	line-height: 150%;
`;

export const InlineLabelStack = styled(Stack)`
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	gap: 4px;
` as typeof Stack;

export const Label = styled(Typography)`
	color: ${({theme}) => theme.palette.text.secondary};
`;

export const Value = styled(Typography)`
	color: ${({theme}) => theme.palette.text.primary};
`;
